import { X } from 'lucide-react';
import { Activity } from '../../types/badges';

interface XPHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  activities: Activity[];
  badgeName: string;
}

export const XPHistoryModal = ({ isOpen, onClose, activities, badgeName }: XPHistoryModalProps) => {
  if (!isOpen) return null;

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }).format(date);
  };

  return (
    <div className="fixed inset-0 z-[60] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" onClick={onClose}>
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="absolute top-0 right-0 pt-4 pr-4">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 focus:outline-none"
            >
              <X size={24} />
            </button>
          </div>

          <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {badgeName} XP History
                </h3>

                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  {activities.length > 0 ? (
                    <div className="divide-y divide-gray-200">
                      {activities.map((activity) => (
                        <div key={activity.id} className="p-4 hover:bg-gray-50">
                          <div className="flex justify-between items-start">
                            <div>
                              <p className="text-sm font-medium text-gray-900">
                                {activity.reason}
                              </p>
                              <p className="text-sm text-gray-500">
                                {activity.awardedBy ? `Awarded by ${activity.awardedBy.name}` : 'Self-awarded'}
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="text-sm font-semibold text-indigo-600">
                                +{activity.amount} XP
                              </p>
                              <p className="text-xs text-gray-500">
                                {formatDate(activity.timestamp)}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="p-4 text-center text-gray-500">
                      No XP history available for this badge
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};